import { render } from "./VerDetallePromocion.vue?vue&type=template&id=2b0c0fc0&scoped=true"
import script from "./VerDetallePromocion.vue?vue&type=script&lang=js"
export * from "./VerDetallePromocion.vue?vue&type=script&lang=js"

import "./VerDetallePromocion.vue?vue&type=style&index=0&id=2b0c0fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0c0fc0"]])

export default __exports__